export default function Cross (props) {

    return (
        <svg stroke={props.stroke} className={props.className} style={props.style} xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 11 11">
            <path d="M 0 9 L 9 0 M 0 0 L 9 9"/>
        </svg>
    )

}